import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fields", "providerType", "title", "nameField", "emptyState", "formContent"]

  connect() {
    const key = this.selectTarget.value
    this.showFields(key)
    this.updateNamePlaceholder(key)
    this.toggleFormVisibility(key)
  }

  changeProvider(event) {
    const providerKey = event.target.value
    this.showFields(providerKey)
    this.updateNamePlaceholder(providerKey)
    this.toggleFormVisibility(providerKey)
    this.providerTypeTarget.value = providerKey
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = event.target.options[event.target.selectedIndex].text
    }
  }

  showFields(providerKey) {
    this.fieldsTargets.forEach(el => {
      const visible = !!providerKey && el.dataset.provider === providerKey
      el.hidden = !visible
      el.querySelectorAll("input, select, textarea").forEach(input => {
        input.disabled = !visible
      })
    })
  }

  updateNamePlaceholder(providerKey) {
    if (!this.hasNameFieldTarget) return
    const fieldsEl = this.fieldsTargets.find(el => el.dataset.provider === providerKey)
    this.nameFieldTarget.placeholder = fieldsEl ? fieldsEl.dataset.namePlaceholder : ""
  }

  toggleFormVisibility(providerKey) {
    if (this.hasEmptyStateTarget) this.emptyStateTarget.hidden = !!providerKey
    if (this.hasFormContentTarget) this.formContentTarget.hidden = !providerKey
  }
}
